import { axios } from "../../lib/axios";
import type { ApiError } from "../../types/ApiError";
import type { LocalizedText } from "./types";

export type RoadmapStudent = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string | null;
  country: string | null;
};

export type RoadmapCourse = {
  courseId: string;
  name: string;
};

export type RoadmapCertification = {
  credentialId: string;
  code: string;
  name: LocalizedText;
  logo: string | null;
  recommendation: string;
};

export type AdminRoadmapStudent = {
  student: RoadmapStudent;
  roadmapId: string;
  submittedAt: string;
  updatedAt: string;
  isPlatformStudent: boolean;
  coursesCount: number;
  courses: RoadmapCourse[];
  certifications: RoadmapCertification[];
};

export type AdminRoadmapStudentsMeta = {
  total: number;
  page: number;
  limit: number;
  lastPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
};

export type AdminRoadmapStudentsData = {
  data: AdminRoadmapStudent[];
  meta: AdminRoadmapStudentsMeta;
};

export type GetAdminRoadmapStudentsParams = {
  page: number;
  limit: number;
  sortBy: string;
  sortOrder: "asc" | "desc";
  isPlatformStudent?: boolean;
  credentialId?: string;
  recommendation?: string;
  q?: string;
};

export type AdminRoadmapStudentsResponse = {
  data?: AdminRoadmapStudentsData;
  error?: ApiError;
};

export const getAdminRoadmapStudents = async (
  params: GetAdminRoadmapStudentsParams
): Promise<AdminRoadmapStudentsResponse> => {
  try {
    const response = await axios.get("/admin/cert-roadmap/students", {
      params,
    });

    return { data: response.data.data };
  } catch (error: unknown) {
    const requestError = error as {
      response?: {
        status?: number;
        data?: { message?: string; error?: string };
      };
    };

    return {
      error: {
        statusCode: requestError.response?.status ?? 500,
        message:
          requestError.response?.data?.message ??
          "We could not load the roadmap students.",
        error: requestError.response?.data?.error,
      },
    };
  }
};
